import { render, staticRenderFns } from "./kpiDetail.vue?vue&type=template&id=6df11232&"
import script from "./kpiDetail.vue?vue&type=script&lang=js&"
export * from "./kpiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports